export { rem, useMantineTheme } from "@mantine/core";
export type {
  TabsValue,
  MantineTheme,
  MantineThemeOverride,
  MantineThemeOther,
  MantineStyleSystemProps,
} from "@mantine/core";
export { useHover } from "@mantine/hooks";
export * from "./components";
